<header
  class="flex justify-between items-center gap-3 h-20 relative w-full">
  <button
    *ngIf="shortMode()"
    appButton
    class="!rounded-full !w-8 !h-8"
    (click)="setShortMode()">
    <app-icon class="text-xl"> menu </app-icon>
  </button>

  <div
    *ngIf="shortMode()"
    class="h-8 mx-3 w-px bg-neutral-100 hidden lg:block"></div>

  <div class="flex gap-1 items-center flex-1">
    <h1 class="text-4xl font-bold text-lPrimary">{{ appBranding.headerTitle }}</h1>
  </div>

  <div class="flex items-center gap-3" appOutsideClick (outsideClick)="open && (open = false)">

    <div
      class="flex gap-2 items-center cursor-pointer bg-white rounded-full px-3 py-1.5"
      (click)="open = !open"
      (keydown.enter)="open = !open"
      tabindex="0">
      <img
        class="w-7 h-min object-cover rounded-full aspect-square bg-lGrayDark"
        alt="avatar"
        width="2800"
        height="2800"
        [src]="user?.imagePerfil || '/assets/icons/person.svg'" />
      <h2 class="text-sm font-medium">{{ (user?.name | initials) || "U" }}</h2>
      <app-icon class="icon-color text-2xl">
        {{ open ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
      </app-icon>
    </div>

    <div
      *ngIf="open"
      class="flex flex-col justify-center items-start gap-2 absolute w-[180px] bg-white rounded-lg shadow-lg border border-gray-200 lg:right-11 right-4 top-[75px] z-50">
      <ul class="w-full">
        <li>
          <a
            routerLink="profile"
            (click)="open = false"
            class="flex items-center w-full gap-2 mb-2 p-2 rounded-md hover:bg-lPrimary hover:text-white transition-colors cursor-pointer group">
            <i class="pi pi-user text-gray-700 group-hover:text-white"></i>
            <h4 class="text-gray-700 text-sm font-medium group-hover:text-white">Meu Perfil</h4>
          </a>
        </li>
        <li>
          <button class="flex items-center w-full gap-2 p-2 rounded-md hover:bg-lPrimary hover:text-white transition-colors cursor-pointer group" (click)="logout()">
            <i class="pi pi-sign-out text-gray-700 group-hover:text-white"></i>
            <h4 class="text-gray-700 text-sm font-medium group-hover:text-white">Sair</h4>
          </button>
        </li>
      </ul>
    </div>
  </div>
</header>

<app-menu menu [menus]="menus" />
